function setupJdgmCarouselArrowStates(wrapperEl) {
  const track = wrapperEl.querySelector('.jdgm-carousel__item-wrapper');
  const leftArrow = wrapperEl.querySelector('.jdgm-carousel__left-arrow');
  const rightArrow = wrapperEl.querySelector('.jdgm-carousel__right-arrow');
  if (!track || !leftArrow || !rightArrow) return;

  function getTranslateX() {
    const transform = getComputedStyle(track).transform;
    if (transform === 'none') return 0;
    const match = transform.match(/matrix\(([^)]+)\)/);
    if (!match) return 0;
    const parts = match[1].split(',').map(parseFloat);
    return parts[4] || 0;
  }

  function setTranslateX(x) {
    track.style.transition = 'none';
    track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    // restore the transition on the next frame so future real slides animate
    requestAnimationFrame(() => {
      track.style.transition = '';
    });
  }

  leftArrow.classList.toggle('jdgm-nav-disabled', getTranslateX() >= -0.5);

  rightArrow.addEventListener('click', () => {
    const beforeX = getTranslateX();
    setTimeout(() => {
      const afterX = getTranslateX();
      // Moving right should only ever make x equal or more negative. If it
      // jumped back toward (or past) 0 instead, Judge.me looped to the
      // start — undo that and treat this as the true end of the list.
      if (afterX > beforeX + 0.5) {
        setTranslateX(beforeX);
        rightArrow.classList.add('jdgm-nav-disabled');
      } else {
        rightArrow.classList.remove('jdgm-nav-disabled');
        leftArrow.classList.remove('jdgm-nav-disabled');
      }
    }, 450);
  });

  leftArrow.addEventListener('click', () => {
    const beforeX = getTranslateX();
    setTimeout(() => {
      const afterX = getTranslateX();
      // Moving left should only ever make x equal or less negative (closer
      // to / at 0). If it jumped further negative instead, Judge.me looped
      // back to the end — undo that and treat this as the true start.
      if (afterX < beforeX - 0.5) {
        setTranslateX(beforeX);
        leftArrow.classList.add('jdgm-nav-disabled');
      } else {
        leftArrow.classList.toggle('jdgm-nav-disabled', afterX >= -0.5);
        rightArrow.classList.remove('jdgm-nav-disabled');
      }
    }, 450);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.jdgm-carousel-wrapper').forEach(setupJdgmCarouselArrowStates);
});
